export default __webpack_public_path__ + "static/media/paypal.71d365f6.png";